"use client";

import { cn } from "@/lib/utils";

interface MiniBarChartProps {
  data: number[];
  width?: number;
  height?: number;
  peakColor?: string;
  barColor?: string;
  className?: string;
}

export function MiniBarChart({
  data,
  width = 160,
  height = 40,
  peakColor = "var(--chart-1)",
  barColor = "var(--chart-3)",
  className,
}: MiniBarChartProps) {
  if (data.length === 0) return null;

  const max = Math.max(...data);
  const barW = width / data.length;
  const gap = 2;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      className={cn("w-full h-10", className)}
      preserveAspectRatio="none"
    >
      {data.map((v, i) => {
        const h = (v / max) * height;
        const x = i * barW + gap / 2;
        const y = height - h;
        const isPeak = v === max;
        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={barW - gap}
            height={h}
            rx="1"
            fill={isPeak ? peakColor : barColor}
            opacity={isPeak ? 1 : 0.6}
          />
        );
      })}
    </svg>
  );
}
